export enum CART_TYPE {
  ONDC = 'ondc',
  DEHAAT = 'dehaat',
}

export const ONDC_ERROR_CODES = {
  PROVIDER_ERROR: new RegExp(/^provider_error/),
  CART_ERROR: new RegExp(/^cart_error/),
  LOCATION_ERROR: new RegExp(/^location_error/),
}

export const ORDER_SUCCESS_DISPLAY_DURATION = 3250

export const PAYMENT_STATUS_POLLING_INTERVAL = 3000

export const PENDING_PAYMENT_DISPLAY_DURATION = 60000

export const CART_ERRORS = {
  CART_401: 'CART_401',
  CART_404: 'CART_404',
}
